import { useLocation, useNavigate } from "react-router-dom"

//Components
import Loader from "../../components/loader"
import Snack from "../../components/snack"

//Extras
import { fontType } from "../../assets/extras"
import { useEffect, useState } from "react"
import { doc, getDoc } from "firebase/firestore"
import { db } from "../../assets/connections"
import NavBar from "./components/nav-bar"
import { main } from "../../assets/coach-assets/constants/colors"

const CoachInfoExt = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const id = location.state ? location.state.id : null
    const ref = location.state ? location.state.ref : null
    const regId = location.state ? location.state.regId : null
    const regRef = location.state ? location.state.regRef : null

    //Variables de la pantalla
    const [variables, setVariables] = useState({
        ref: ref,
        id: id,
        regRef: regRef,
        regId: regId,
        data: null,
        loading: true
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        setTimeout(() => {
            let contSnack = document.getElementById("contSnack")

            let snack = document.createElement("div")
            snack.classList.add("snack")

            snack.innerHTML = status == "success" ?
                "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #56d600;'></div>"
                : status == "warning" ?
                    "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                    : status == "error" ?
                        "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                        "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                        "<div className='snackBar' style='background-color: #c20000;'></div>"
                        : ""

            contSnack.appendChild(snack)
            setTimeout(() => {
                snack.remove()
            }, 5000)
        }, 5)
    }

    //Funcion que obtiene los datos del registro
    const getData = async () => {
        await getDoc(doc(doc(db, regRef), "Historial", regId)).then(r => {
            setVariables(prev => ({
                ...prev,
                loading: false,
                data: r.data()
            }))
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }

    useEffect(() => {
        const token = localStorage.getItem("authTokenCoach")

        if(!token || !location.state) {
            navigate("/coach", {
                replace: true
            })
        } else {
            getData()
        }
    }, [])

    if (variables.loading)
        return (
            <Loader
                loading={variables.loading}
            />
        )

    if (!variables.loading)
        return (
            <div style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}>

                <Snack />

                <NavBar
                    title={variables.data.nombre_clase.toUpperCase()}
                />

                <p style={{
                    width: "100%",
                    marginTop: 10,
                    textAlign: "center",
                    fontFamily: fontType.title,
                    fontSize: 30
                }}>Asistencias</p>

                <div style={{
                    border: "1px solid black",
                    width: "90%",
                    marginTop: 3,
                    borderRadius: 5,
                    padding: 10,
                    maxWidth: 600
                }}>
                    {
                        variables.data.jugadores_registrados.map((v, i) => {
                            return (
                                <div style={{
                                    borderBottom: "1px solid " + main,
                                    padding: 3,
                                    marginTop: 5,
                                    marginBottom: 10
                                }}>
                                    <p style={{
                                        fontFamily: fontType.text
                                    }}>{v.nombre}</p>
                                </div>
                            )
                        })
                    }
                    {
                        variables.data.jugadores_noRegistrados.map((v, i) => {
                            return (
                                <div style={{
                                    borderBottom: "1px solid " + main,
                                    padding: 3,
                                    marginTop: 5,
                                    marginBottom: 10
                                }}>
                                    <p style={{
                                        fontFamily: fontType.text
                                    }}>{v.nombre}</p>
                                </div>
                            )
                        })
                    }
                </div>

                <p style={{ width: "100%", marginTop: "20px", textAlign:"center", fontFamily: fontType.title, fontSize: 30 }}>Comentarios</p>

                <div
                    style={{
                        border: "1px solid black",
                        width: "90%",
                        maxWidth: 600,
                        marginTop: "3px",
                        borderRadius: "5px",
                        padding: "10px",
                        textAlign: "center",
                        fontFamily: fontType.text
                    }}
                >
                    {variables.data.comentarios_clase === ""
                        ? "Sin comentarios"
                        : variables.data.comentarios_clase}
                </div>

                <div
                    style={{
                        width: "90%",
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "20px",
                        maxWidth: 600
                    }}
                >
                    <span style={{ fontFamily: fontType.title }}>Leccion:&nbsp;</span>
                    <span style={{
                        fontFamily: fontType.text
                    }}>
                        {variables.data.leccion_clase === "" ? "No especificada" : variables.data.leccion_clase}
                    </span>
                </div>

                <div
                    style={{
                        width: "90%",
                        maxWidth: 600,
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "10px"
                    }}
                >
                    <span style={{ fontFamily: fontType.title }}>Duracion de clase:&nbsp;</span>
                    <span style={{
                        fontFamily: fontType.text
                    }}>{variables.data.duracion_clase}hrs.</span>
                </div>

                <div
                    style={{
                        width: "90%",
                        maxWidth: 600,
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "10px"
                    }}
                >
                    <span style={{ fontFamily: fontType.title }}> Fecha/Hora:&nbsp;</span>
                    <span style={{
                        fontFamily: fontType.text
                    }}>{variables.data.fecha_clase} | {variables.data.hora_clase}</span>
                </div>


            </div>
        )
}

export default CoachInfoExt